/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_CatalogInputs */

const en_fix_catalog = /** @type {(inputs: Fix_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingredient`)
};

const de_fix_catalog = /** @type {(inputs: Fix_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutat`)
};

/**
* | output |
* | --- |
* | "Ingredient" |
*
* @param {Fix_CatalogInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_catalog = /** @type {((inputs?: Fix_CatalogInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_CatalogInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_catalog(inputs)
	return en_fix_catalog(inputs)
});